module.exports = __webpack_public_path__ + "img/slide-two.b590e089.jpg";